import gql from "graphql-tag";

export const getActividadesEconomicas = gql`
  query ($query: GetActividadesEconomicasQuery!) {
    getActividadesEconomicas(query: $query) {
      scrm_craec_id
      scrm_craec_codigo
      scrm_craec_abreviatura
      scrm_craec_nombre
    }
  }
`;

export const getDepartamentos = gql`
  query ($query: GetDepartamentosQuery!) {
    getDepartamentos(query: $query) {
      sadm_addep_id
      sadm_addep_nombre
      sadm_addep_codigo
    }
  }
`;

export const getMunicipios = gql`
  query ($query: GetMunicipiosQuery!) {
    getMunicipios(query: $query) {
      sadm_admun_id
      sadm_admun_codigo
      sadm_admun_nombre
    }
  }
`;

export const getDistritos = gql`
  query ($query: GetDistritosQuery!) {
    getDistritos(query: $query) {
      sadm_addistri_id
      sadm_addistri_codigo
      sadm_addistri_nombre
    }
  }
`;
